import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ShieldCheck, Users, Award, Briefcase } from "lucide-react";

const AboutPage = () => {
    return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#0f3e3e] to-[#145858] text-white py-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            About Safety Training Institute
          </h1>
          <p className="text-lg md:text-xl opacity-90 max-w-4xl mx-auto">
            Professional Safety Training & Certification Center in Bahanaga,
            Balasore, Odisha
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#0f3e3e] mb-6">
              Who We Are
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              <strong>Safety Training Institute, Bahanaga</strong> is a
              professional training center located at Bahanaga, Balasore, Odisha
              (PIN: 756042). We specialize in high-quality safety training and
              certification programs designed to prepare students for real-world
              industrial and workplace environments.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Our institute focuses on building safety-aware professionals who
              can work confidently in industries such as construction,
              manufacturing, logistics, and other high-risk workplaces.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="p-6 border rounded-xl text-center hover:shadow-lg transition">
              <ShieldCheck className="w-10 h-10 mx-auto text-[#0f3e3e] mb-4" />
              <h3 className="font-semibold text-lg">Safety First</h3>
              <p className="text-sm text-muted-foreground">
                Industry-standard safety practices
              </p>
            </div>

            <div className="p-6 border rounded-xl text-center hover:shadow-lg transition">
              <Users className="w-10 h-10 mx-auto text-[#0f3e3e] mb-4" />
              <h3 className="font-semibold text-lg">Expert Trainers</h3>
              <p className="text-sm text-muted-foreground">
                Highly experienced professionals
              </p>
            </div>

            <div className="p-6 border rounded-xl text-center hover:shadow-lg transition">
              <Award className="w-10 h-10 mx-auto text-[#0f3e3e] mb-4" />
              <h3 className="font-semibold text-lg">Certification</h3>
              <p className="text-sm text-muted-foreground">
                Government & industry recognized
              </p>
            </div>

            <div className="p-6 border rounded-xl text-center hover:shadow-lg transition">
              <Briefcase className="w-10 h-10 mx-auto text-[#0f3e3e] mb-4" />
              <h3 className="font-semibold text-lg">Career Focus</h3>
              <p className="text-sm text-muted-foreground">
                Job-ready practical training
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-[#f8f9fa] py-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-[#0f3e3e] mb-6">
            Our Mission
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Our mission is to develop skilled and safety-aware professionals by
            providing government-recognized, industry-relevant courses supported
            by modern training facilities, practical sessions, and personalized
            guidance for long-term career growth.
          </p>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-semibold text-center text-[#0f3e3e] mb-12">
            Why Choose Us
          </h2>

          <div className="grid md:grid-cols-2 gap-6">
            {[
              "Professional and experienced trainers",
              "Practical and industry-oriented training",
              "Affordable fees with easy admission process",
              "Certificate provided after course completion",
              "100% student support for career development",
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-4 p-5 border rounded-lg hover:shadow-md transition"
              >
                <span className="w-8 h-8 flex items-center justify-center bg-[#0f3e3e] text-white rounded-full font-bold">
                  ✓
                </span>
                <p className="text-muted-foreground">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer/>
    </div>
    
  );
};


export default AboutPage;